import { usePlans } from '@/contexts/PlanRulesContext';
import { Dialog, DialogContent } from '../ui/dialog';
import { Building2, Check, Loader2, BarChart3, Wifi, Shield, Brain } from 'lucide-react';
import { PLAN_NAME_MAPPER } from '@/constants';


function SettingUpCompset({ isSaving, setupStep, maxStep, }) {

    const { planRules } = usePlans();

    const isRegularPlan = planRules?.plan_info?.plan_name == PLAN_NAME_MAPPER.regular


    return (
        <div>
            <Dialog open={isSaving} onOpenChange={() => { }}>
                <DialogContent className="max-w-md [&>button]:hidden" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="compset-setup-progress">
                    <div className="py-maxStep text-center">
                        {/* Animated icon */}
                        <div className="relative mx-auto w-20 h-20 mb-6">
                            <div className="absolute inset-0 rounded-full bg-primary/10 animate-ping" style={{ animationDuration: '2s' }} />
                            <div className="relative w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
                                {setupStep < maxStep ? (
                                    <Loader2 className="w-8 h-8 text-primary animate-spin" />
                                ) : (
                                    <Check className="w-8 h-8 text-primary" />
                                )}
                            </div>
                        </div>

                        <h3 className="text-xl font-semibold mb-2">
                            {setupStep < maxStep ? 'Setting Up Your Compset' : 'All Set!'}
                        </h3>
                        <p className="text-sm text-muted-foreground mb-8">
                            {setupStep < maxStep
                                ? 'Please wait while we configure everything for you...'
                                : 'Redirecting to your dashboard...'}
                        </p>

                        {/* Progress steps */}
                        <div className="space-y-3 text-left max-w-xs mx-auto">
                            {[
                                { icon: Building2, label: 'Registering your hotel & competitors' },
                                { icon: Wifi, label: 'Connecting to OTA data sources' },
                                { icon: BarChart3, label: 'Initializing analytics engine' },
                                ...!isRegularPlan
                                    ? [{ icon: Brain, label: 'Initializing AI engine' }]
                                    : []
                                ,
                                { icon: Shield, label: 'Preparing your dashboard' },
                            ].map((item, i) => (
                                <div key={i} className="flex items-center gap-3">
                                    <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-500 ${i < setupStep ? 'bg-primary text-primary-foreground' :
                                        i === setupStep ? 'bg-primary/20 text-primary' :
                                            'bg-muted text-muted-foreground'
                                        }`}>
                                        {i < setupStep ? (
                                            <Check className="w-3.5 h-3.5" />
                                        ) : (
                                            <item.icon className="w-3.5 h-3.5" />
                                        )}
                                    </div>
                                    <span className={`text-sm transition-colors duration-300 ${i < setupStep ? 'text-foreground font-medium' :
                                        i === setupStep ? 'text-foreground' :
                                            'text-muted-foreground'
                                        }`}>
                                        {item.label}
                                    </span>
                                    {i === setupStep && i < maxStep && (
                                        <Loader2 className="w-3.5 h-3.5 animate-spin text-primary ml-auto" />
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Progress bar */}
                        <div className="mt-8 w-full bg-muted rounded-full h-1.5 overflow-hidden">
                            <div
                                className="h-full bg-primary rounded-full transition-all duration-700 ease-out"
                                style={{ width: `${Math.min((setupStep / maxStep) * 100, 100)}%` }}
                            />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SettingUpCompset;